export default "__VITE_ASSET__ONF$VAyZ__"